<template>
  <div>
    <el-dialog :visible.sync="viewEditOrderDialogVisible" width="95%" :show-close="false" :close-on-click-modal="false">
      <span slot="title" class="font-weight-bold h4" v-if="currentOrderDetailsFirstItem">
        <div class="d-flex justify-content-between">
          <span>
            {{ isConfirmingOrder ? "Confirm Order" : "Edit Order" }}
            <el-tooltip
              :popper-class="currentOrderHasBeenCancelled ? 'bg-danger text-olf-white' : 'bg-secondary text-olf-white'"
              class="item"
              effect="light"
              :content="currentOrderHasBeenCancelled ? 'this order has been cancelled' : 'This order has been edited'"
              placement="bottom"
            >
              <i
                v-if="currentOrderHasBeenEdited || currentOrderHasBeenCancelled"
                class="fa fa-exclamation-triangle mr-1"
                :class="[
                  { 'text-secondary': currentOrderHasBeenEdited && !currentOrderHasBeenCancelled },
                  { 'text-danger': currentOrderHasBeenCancelled },
                ]"
                style="font-size: 20px"
              ></i>
            </el-tooltip>
          </span>
          <span>
            <i
              @click="hasChangeOccured ? showRemovalConfirmation(true) : $emit('update:viewEditOrderDialog', false)"
              class="fas fa-lg fa-times"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </span>
        </div>
      </span>
      <el-card>
      <el-row :gutter="20" v-if="currentOrderDetailsFirstItem" class="customLineHeight">
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span class="font-weight-bold"> Order Id </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span>
            {{ currentOrderDetailsFirstItem.orderId }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span class="font-weight-bold"> Customer </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span>
            {{ currentOrderDetailsFirstItem.account }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="currentOrderDetailsFirstItem && !isContract">
          <span class="font-weight-bold"> Payment Terms </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="currentOrderDetailsFirstItem && !isContract">
          <span>
            {{ currentOrderDetailsFirstItem.credit_days }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="12" :md="4" :lg="3" class="pt-1" v-if="isDeliveredIn && currentOrderDetailsFirstItem">
          <span class="font-weight-bold"> Delivery Date </span>
        </el-col>
        <el-col :xs="12" :sm="12" :md="4" :lg="3" class="pt-1" v-if="isDeliveredIn && currentOrderDetailsFirstItem">
          <span>
            {{ currentOrderDetailsFirstItem.deliveryDate }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span class="font-weight-bold"> Date </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span style="white-space: nowrap">
            {{ currentOrderDetailsFirstItem.date }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span class="font-weight-bold">
            {{ isBunkering ? "Network" : "Terminal" }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
          <span>
            {{ currentOrderDetailsFirstItem.terminal }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" v-if="isDeliveredIn" class="pt-1">
          <span class="font-weight-bold"> Delivery Location </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" v-if="isDeliveredIn" class="pt-1">
          <span>
            {{ currentOrderDetailsFirstItem.delivery_location }}
          </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="hasMultipleRefs() === false">
          <span class="font-weight-bold"> Ref </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="hasMultipleRefs() === false">
          <span>
            {{ currentOrderDetailsFirstItem.reference }}
          </span>
        </el-col>
      </el-row>
      <el-form
        ref="liftingPeriodForm"
        :model="editOrderForm"
        label-width="120px"
        label-position="left"
        :rules="liftingPeriodRules"
        v-if="currentOrderDetailsFirstItem && !isBunkering"
      >
        <el-row :gutter="24" class="pt-2 customLineHeight" :class="{'customFontSize' : $breakpoint.lgAndUp }">
          <el-col
            :xs="12"
            :sm="6"
            :md="4"
            :lg="3"
            :class="!isConfirmingOrder && !currentOrderHasBeenCancelled ? 'pt-2' : 'pt-2'"
          >
            <span class="font-weight-bold"> Lifting Period </span>
          </el-col>
          <el-col
            :xs="
              !((isConfirmingOrder || currentOrderHasBeenCancelled || isNegotiation) && currentOrderDetailsFirstItem)
                ? 16
                : 12
            "
            :sm="6"
            :md="5"
            :lg="4"
            class="pt-2"
          >
            <el-form-item
              prop="liftingPeriod"
              v-if="!isConfirmingOrder && !currentOrderHasBeenCancelled && !isNegotiation"
            >
              <el-date-picker
                size="mini"
                v-model="editOrderForm.liftingPeriod"
                type="daterange"
                range-separator="-"
                :format="'dd/MM/yyyy'"
                :value-format="'dd/MM/yyyy'"
                start-placeholder="Start date"
                end-placeholder="End date"
                :picker-options="pickerStartOptions"
              >
              </el-date-picker>
            </el-form-item>
            <span
              v-if="
                (isConfirmingOrder || currentOrderHasBeenCancelled || isNegotiation) && currentOrderDetailsFirstItem
              "
            >
              {{ editOrderForm.liftingPeriod[0] }} - {{ editOrderForm.liftingPeriod[1] }}
            </span>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="24" v-if="currentOrderDetailsFirstItem && !isConfirmingOrder" class="pb-2 customLineHeight" :class="{'customFontSize' : $breakpoint.lgAndUp }">
        <el-col :xs="12" :sm="6" :md="4" :lg="3" class="mt-2 pt-1">
          <span class="font-weight-bold"> Status </span>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="4" class="pt-1 mt-2" :class="`text-${calculateOrderDisplay().textColor}`">
          <span>
            {{ calculateOrderDisplay().text }}
          </span>
        </el-col>
        <el-col :xs="6" :sm="5" :md="4" :lg="4" class="pt-1">
          <el-button size="small" type="danger" @click="cancelOrder" v-if="!currentOrderHasBeenCancelled"
            >Cancel Order</el-button
          >
        </el-col>
        <el-col :xs="12" :sm="5" :md="4" :lg="4" class="pt-1"> </el-col>
      </el-row>
      </el-card>
      <el-form
        ref="form"
        :model="{ currentOrderDetails }"
        label-width="120px"
        label-position="left"
        v-if="currentOrderDetailsFirstItem"
      >
        <!-- Cards for smaller Screens -->
        <div v-if="currentOrderDetailsFirstItem && $breakpoint.mdAndDown" class="pb-2">
          <el-card class="py-1 mb-3" v-for="(order, index) in currentOrderDetails" :key="index">
            <el-row :gutter="20">
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering"> <span class="font-weight-bold"> Product </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering">
                <span> {{ order.fuel }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering"> <span class="font-weight-bold"> Network </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                <span> {{ order.terminal }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="hasMultipleRefs()">
                <span class="font-weight-bold"> Ref </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="hasMultipleRefs()">
                <span> {{ getReferenceLineNumber(index) }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="manageOrderNumbersEnabled">
                <span class="font-weight-bold"> Order No. </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="manageOrderNumbersEnabled">
                <span> {{ order.contractNumber ? order.contractNumber : "-" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <span class="font-weight-bold"> Release No. </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <span> {{ order.releaseNumber ? order.releaseNumber : "-" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <span class="font-weight-bold"> Movement No. </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <span> {{ order.movementNumber ? order.movementNumber : "-" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                <span class="font-weight-bold"> Account No. </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                <span> {{ order.bunkeringAccountNumber }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Bio Pricing </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span> {{ order.bioPrice }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Measurement </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span> {{ order.measurement }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isContract">
                <span class="font-weight-bold"> Payment Terms </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isContract">
                <span> {{ order.credit_days }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span class="font-weight-bold"> {{ isDeliveredIn ? "Ex-Rack Price ppl" : "Price ppl" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <el-form-item
                  v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                  :prop="'currentOrderDetails.' + index + '.price'"
                  :rules="formRules.price"
                  class="pt-3 pb-2"
                >
                  <el-input
                    :disabled="isNegotiation"
                    @input.native="onInputCleaveFormatValue(index, 'price')"
                    v-cleave="numeralPositive"
                    v-model="order.price"
                    v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                  >
                  </el-input>
                </el-form-item>
                <span v-else>
                  {{ order.price | priceformat }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span class="font-weight-bold"> Haulage ppl </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span> {{ order.haulage }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span class="font-weight-bold"> Delivered Price </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span> {{ ((stringToNumber(order.price) + stringToNumber(order.haulage)).toFixed(2)) | priceformat }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Vol/L </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <el-form-item
                  v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                  :prop="'currentOrderDetails.' + index + '.quantity'"
                  :rules="formRules.quantity"
                  class="pt-3 pb-2"
                >
                  <el-input
                    :disabled="isNegotiation"
                    @input.native="onInputCleaveFormatValue(index, 'quantity')"
                    v-cleave="naturalNumber"
                    v-model="order.quantity"
                  >
                  </el-input>
                </el-form-item>
                <span v-else>
                  {{ order.quantity }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Total (£) </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span v-if="isDeliveredIn">
                    {{ ((((stringToNumber(order.price) + stringToNumber(order.haulage)) * stringToNumber(order.quantity)) / 100).toFixed(2)) | priceformat }}
                  </span>
                  <span v-else>
                    {{ (((stringToNumber(order.price) * stringToNumber(order.quantity)) / 100).toFixed(2)) | priceformat }}
                  </span>
              </el-col>
            </el-row>
            <orderPriceBreakDown
              v-if="currentOrderDetailsFirstItem.pricingEngineEnabled && getOrderMarketWindow"
              :cards="true"
              :index="index"
              :order="order"
              :getOrderMarketWindow="getOrderMarketWindow"
              :productConfig="productConfig"
              :bioProductConfig="bioProductConfig"
              :isContract="isContract"
            />
          </el-card>
        </div>
        <el-row class="pt-3 pb-1" v-if="$breakpoint.lgAndUp">
          <el-col :span="24">
            <el-table
              ref="table"
              :data="currentOrderDetails"
              :fit="true"
              size="mini"
              :header-cell-class-name="tableHeaderClass"
            >
              <el-table-column align="left" label="Product" min-width="100px" v-if="!isBunkering">
                  <template slot-scope="scope">
                    <span>{{ scope.row.fuel }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Network" min-width="100px" v-if="isBunkering">
                  <template slot-scope="scope">
                    <span>{{ scope.row.terminal }}</span>
                  </template>
                </el-table-column>

              <el-table-column align="left" label="Order No." min-width="100px" v-if="manageOrderNumbersEnabled">
                <template slot-scope="scope">
                  <span> {{ scope.row.contractNumber ? scope.row.contractNumber : "-" }} </span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="Release No."
                min-width="100px"
                v-if="!isBunkering && manageOrderNumbersEnabled"
              >
                <template slot-scope="scope">
                  <span> {{ scope.row.releaseNumber ? scope.row.releaseNumber : "-" }} </span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="Movement No."
                min-width="100px"
                v-if="!isBunkering && manageOrderNumbersEnabled"
              >
                <template slot-scope="scope">
                  <span> {{ scope.row.movementNumber ? scope.row.movementNumber : "-" }} </span>
                </template>
                
              </el-table-column>
                 <el-table-column
                  align="left"
                  label="Ref"
                  v-if="hasMultipleRefs()"
                  :min-width="brand ? '100px' : '120px'"
                >
                  <template slot-scope="scope">
                    <span> {{ getReferenceLineNumber(scope.$index) }} </span>
                  </template>
                </el-table-column>

              <el-table-column align="left" label="Account No." v-if="isBunkering" min-width="100px">
                <template slot-scope="scope">
                  <span> {{ scope.row.bunkeringAccountNumber }} </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Bio Pricing" min-width="100px">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.bioPrice }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Measurement" min-width="100px">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.measurement }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Payment Terms" min-width="100px" v-if="isContract">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.credit_days }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                :label="isDeliveredIn ? 'Ex-Rack Price ppl' : 'Price ppl'"
                min-width="120px"
              >
                <template slot-scope="scope">
                  <el-form-item
                    v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                    :prop="'currentOrderDetails.' + scope.$index + '.price'"
                    :rules="formRules.price"
                    class="pt-3 pb-2"
                  >
                    <el-input
                      :disabled="isNegotiation"
                      @input.native="onInputCleaveFormatValue(scope.$index, 'price')"
                      v-cleave="numeralPositive"
                      v-model="scope.row.price"
                      v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                    >
                    </el-input>
                  </el-form-item>
                  <span v-else>
                    {{ scope.row.price | priceformat }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Haulage ppl" min-width="120px" v-if="isDeliveredIn">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.haulage }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Delivered Price" min-width="120px" v-if="isDeliveredIn">
                <template slot-scope="scope">
                  <span>
                    {{ (stringToNumber(scope.row.price) + stringToNumber(scope.row.haulage)) | priceformat }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Vol/L" min-width="120px">
                <template slot-scope="scope">
                  <el-form-item
                    v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                    :prop="'currentOrderDetails.' + scope.$index + '.quantity'"
                    :rules="formRules.quantity"
                    class="pt-3 pb-2"
                  >
                    <el-input
                      :disabled="isNegotiation"
                      @input.native="onInputCleaveFormatValue(scope.$index, 'quantity')"
                      v-cleave="naturalNumber"
                      v-model="scope.row.quantity"
                    >
                    </el-input>
                  </el-form-item>
                  <span v-else>
                    {{ scope.row.quantity }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Total GBP" min-width="130px">
                <template slot-scope="scope">
                  <span v-if="isDeliveredIn">
                    {{ ((((stringToNumber(scope.row.price) + stringToNumber(scope.row.haulage)) * stringToNumber(scope.row.quantity)) / 100).toFixed(2)) | priceformat }}
                  </span>
                  <span v-else>
                    {{ (((stringToNumber(scope.row.price) * stringToNumber(scope.row.quantity)) / 100).toFixed(2)) | priceformat }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column min-width="50px" v-if="currentOrderDetailsFirstItem.pricingEngineEnabled">
                <template slot-scope="scope">
                  <el-tooltip
                    popper-class="bg-secondary text-olf-white"
                    class="item"
                    effect="light"
                    :content="expandedRowIndex.includes(scope.$index) ? 'Hide Price Breakdown' : 'Show Price Breakdown'"
                    placement="top"
                  >
                    <i
                      class="mr-1 text-secondary"
                      :class="expandedRowIndex.includes(scope.$index) ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                      style="font-size: 20px"
                      @click="toggleExpand(scope.row, scope.$index)"
                    >
                    </i>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column type="expand" v-if="currentOrderDetailsFirstItem.pricingEngineEnabled" width="1px">
                <template slot-scope="scope">
                  <orderPriceBreakDown
                    v-if="currentOrderDetailsFirstItem.pricingEngineEnabled && getOrderMarketWindow"
                    :key="scope.$index"
                    :index="scope.$index"
                    :order="scope.row"
                    :getOrderMarketWindow="getOrderMarketWindow"
                    :productConfig="productConfig"
                    :bioProductConfig="bioProductConfig"
                    :isContract="isContract"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :xs="24" :md="12" class="pb-4 mt-2">
          <el-card>
            <label> Order Notes </label>
            <br/>
            {{ currentOrderDetailsFirstItem && currentOrderDetailsFirstItem.orderNotes }}
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer-center">
        <el-row :gutter="20">
          <el-button
            size="small"
            type="info"
            @click="hasChangeOccured ? showRemovalConfirmation(true) : $emit('update:viewEditOrderDialog', false)"
            >Close</el-button
          >
          <el-button
            size="small"
            :type="hasChangeOccured || isConfirmingOrder ? 'success' : 'info'"
            @click="saveChanges"
            v-if="!currentOrderHasBeenCancelled"
            :disabled="!hasChangeOccured && !isConfirmingOrder"
          >
            {{
              manageOrderNumbersEnabled && isConfirmingOrder
                ? "Add Order Numbers"
                : !manageOrderNumbersEnabled && isConfirmingOrder
                ? "Confirm Order"
                : "Save Changes"
            }}
          </el-button>
        </el-row>
      </span>
    </el-dialog>
    <editDeleteOrderConfirmationDialog
      v-if="viewEditDeleteConfirmationDialog"
      :viewEditDeleteConfirmationDialog.sync="viewEditDeleteConfirmationDialog"
      :viewEditOrderDialogVisible.sync="viewEditOrderDialogVisible"
      :isCancelingOrder.sync="isCancelingOrder"
      :isConfirmingOrder.sync="isConfirmingOrder"
      :viewEditOrderDialog.sync="viewEditOrderDialog"
      @closeEditOrderDialog="closeEditOrderDialog"
      :orderToUpdate="editOrderForm"
      :orderId="currentOrderDetailsFirstItem._id"
      :isBunkering="isBunkering"
      :isComingFromOrderCapture="isComingFromOrderCapture"
    />
    <manageOrderNumbersDialog
      v-if="viewManageOrderNumbersDialog"
      :viewManageOrderNumbersDialog.sync="viewManageOrderNumbersDialog"
      :viewEditOrderDialogVisible.sync="viewEditOrderDialogVisible"
      @closeEditOrderDialog="closeEditOrderDialog"
      :orderToUpdate="currentOrderDetails"
      :orderId="currentOrderDetailsFirstItem._id"
      :isBunkering="isBunkering"
      :isComingFromOrderCapture="isComingFromOrderCapture"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import breakpoint from "@/mixins/index";
import orderPriceBreakDown from "../components/Tools/OrderPriceBreakDown.vue";
import { getOrderStatusDisplay } from "@/util/orderBuilder";
import { formatStringToNumber } from "@/util/util";
import { makeGenericContractFromContractFrequency } from "@/util/contracts";
import { getBasket } from "../api/basket.js";
import { getOffers } from "../api/offers.js";
import isEqual from "lodash/isEqual";
import moment from "moment";
import editDeleteOrderConfirmationDialog from "./EditDeleteOrderConfirmation.vue";
import manageOrderNumbersDialog from "./ManageOrderNumbersDialog.vue";
export default {
  components: {
    editDeleteOrderConfirmationDialog,
    manageOrderNumbersDialog,
    orderPriceBreakDown,
  },
  mixins: [breakpoint],
  props: {
    orders: {
      type: Array,
      required: true,
      default: () => [],
    },
    viewEditOrderDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    isConfirmingOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
    isComingFromOrderCapture: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const validateLiftingPeriod = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error(" "));
      }
      callback();
    };
    const validateNumberInput = (rule, value, callback) => {
      if (this.stringToNumber(value) <= 0) {
        callback(new Error("Please enter a value greater than 0"));
      } else {
        callback();
      }
    };
    const validateOfferInput = async (rule, value, callback) => {
      const index = Number(rule.field.split(".")[1]);
      if(!this.orders || this.orders.length === 0){
        callback();
      }
      await this.getOfferFromOrder(index);
      if (this.currentOfferFromOrder) {
        const { maximumAvailable, minimumOrderQuantity } = this.currentOfferFromOrder;
        const convertedValue = this.stringToNumber(value);
        const { quantity } = this.orders[index];
        if ((convertedValue < minimumOrderQuantity) || (convertedValue > (maximumAvailable + this.stringToNumber(quantity)))) {
          callback(new Error(`Please enter a value between ${minimumOrderQuantity} and ${maximumAvailable + this.stringToNumber(quantity)}`));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      currentOfferFromOrder: null,
      liveOffers: [],
      expandedRowIndex: [],
      liftingPeriodFormValid: false,
      formValid: false,
      viewManageOrderNumbersDialog: false,
      viewEditDeleteConfirmationDialog: false,
      viewEditOrderDialogVisible: true,
      isCancelingOrder: false,
      ordersOriginal: [],
      ordersEditable: [],
      orderBasket: null,
      orderMarketWindow: null,
      liftingPeriodRules: {
        liftingPeriod: [{ required: true, validator: validateLiftingPeriod, trigger: ["change", "blur"] }],
      },
      formRules: {
        price: [{ required: true, validator: validateNumberInput, trigger: ["change", "blur"] }],
        quantity: [{ required: true, validator: validateOfferInput, trigger: ["change", "blur"] }],
      },
      pickerStartOptions: {
        disabledDate: this.disabledStartDates,
      },
      editOrderForm: {
        liftingPeriod: [],
        offers: [],
      },
    };
  },
  computed: {
    ...mapGetters("inputCheckers", ["numeralPositive", "naturalNumber"]),
    ...mapGetters("itemRemoval", ["showItemRemovalConfirmation", "unsavedChangesRemovalConfirmed"]),
    ...mapGetters("metadata", ["bioProductConfig", "productConfig", "blendedProductConfig", "staMatrix"]),
    ...mapGetters("login", ["getAccountType"]),
    manageOrderNumbersEnabled() {
      return this.$store.getters["login/isUpdateOrderNumbersEnabled"];
    },
    hasChangeOccured() {
      const changeableFields = this.ordersEditable.map((order) => {
        return {
          quantityOrdered: order.quantity,
          price: order.price,
          liftingPeriod: this.isBunkering ? null : this.editOrderForm.liftingPeriod,
        };
      });
      const originalFields = this.ordersOriginal.map((order) => {
        return {
          quantityOrdered: order.quantity,
          price: order.price,
          liftingPeriod: this.isBunkering ? null : this.assignLiftingPeriod(order),
        };
      });
      return !isEqual(originalFields, changeableFields);
    },
    getOrderMarketWindow() {
      return this.orderMarketWindow;
    },
    currentOrderDetails() {
      return this.ordersEditable;
    },
    currentOrderDetailsFirstItem() {
      return this.currentOrderDetails.length ? this.currentOrderDetails[0] : null;
    },
    isNegotiation() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.isNegotiation;
    },
    isContract() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.offer_type === "Contract";
    },
    isBunkering() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.product_type === "Bunkering";
    },
    isDeliveredIn() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.haulage;
    },
    currentOrderHasBeenEdited() {
      return this.currentOrderDetailsFirstItem.edited;
    },
    currentOrderHasBeenCancelled() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.orderCancelled ? true : false;
    },
    currentFormDetails() {
      return this.editOrderForm;
    },
  },
  watch: {
    showItemRemovalConfirmation() {
      if (!this.showItemRemovalConfirmation && !this.viewManageOrderNumbersDialog) {
        this.viewEditOrderDialogVisible = true;
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
    unsavedChangesRemovalConfirmed() {
      if (this.unsavedChangesRemovalConfirmed && !this.viewManageOrderNumbersDialog) {
        this.$emit("update:viewEditOrderDialog", false);
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
  },
  beforeCreate() {},
  async created() {
    const { offers } = await getOffers({offerIds: this.orders.map(({offerId}) => offerId) });
    this.liveOffers = offers;
  },
  beforeMount() {},
  async mounted() {
    // we make a deep copy of the orders object to ensure we dont modify the props data
    // will be used laateer to comparee again ordersEditable to see if changes have occured
    this.ordersOriginal = JSON.parse(JSON.stringify(this.orders));
    if (this.isConfirmingOrder && this.manageOrderNumbersEnabled && this.isComingFromOrderCapture) {
      this.openManageOrderNumbersDialog();
    } else if (this.isConfirmingOrder && !this.manageOrderNumbersEnabled && this.isComingFromOrderCapture) {
      this.saveChanges();
    }
    // create a deep copy of the originalOrdere object to be modified by user
    this.copyOrdersToEditableObject();
    this.createOrderObject();
    if (this.currentOrderDetailsFirstItem) {
      this.editOrderForm.liftingPeriod = this.assignLiftingPeriod(this.currentOrderDetailsFirstItem);
      await this.retrieveMarketWindowAndBasketData();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    hasMultipleRefs() {
      if (this.currentOrderDetailsFirstItem) {
        let references = this.currentOrderDetailsFirstItem.reference.split(';');
        if ((this.isContract || this.isBunkering) && references.length > 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false
      }
    },
    getReferenceLineNumber(index) {
      if (this.hasMultipleRefs() && this.currentOrderDetailsFirstItem) {
        let references = this.currentOrderDetailsFirstItem.reference.split(';');
        let currentReference = references[index];
        return currentReference ? currentReference.trim() : '-';
      }
    },
    calculateOrderDisplay() {
      return getOrderStatusDisplay(this.currentOrderDetailsFirstItem)
    },
    async getOfferFromOrder(index){
      const order = this.orders[index];
      if (!this.currentOfferFromOrder || order.offerId !== this.currentOfferFromOrder._id) {
        let result = await this.$store.dispatch('offers/getOfferById', order.offerId)
        const { data } = result;
        this.currentOfferFromOrder = data.offer;
      }
      return makeGenericContractFromContractFrequency(this.currentOfferFromOrder);
    },
    onInputCleaveFormatValue(index, type) {
      if (type === "price") {
        this.currentOrderDetails[index].price = event.target._vCleave.getFormattedValue();
      } else {
        this.currentOrderDetails[index].quantity = event.target._vCleave.getFormattedValue();
      }
    },
    toggleExpand(row, index) {
      let currentTable = this.$refs.table;
      currentTable.toggleRowExpansion(row);
      if (this.expandedRowIndex.includes(index)) {
        this.expandedRowIndex = this.expandedRowIndex.filter((x) => x !== index);
      } else {
        this.expandedRowIndex.push(index);
      }
    },
    stringToNumber(value) {
      return formatStringToNumber(value);
    },
    copyOrdersToEditableObject() {
      // we check the original object if it isDelivered in
      if (this.ordersOriginal && this.ordersOriginal[0].haulage) {
        this.ordersOriginal.forEach((order) => {
          const priceWithoutHaulage = this.stringToNumber(order.price) - this.stringToNumber(order.haulage);
          order.price = Number(priceWithoutHaulage.toFixed(2));
        });
      }
      this.ordersEditable = JSON.parse(JSON.stringify(this.ordersOriginal));
    },
    async retrieveMarketWindowAndBasketData() {
      if (this.currentOrderDetailsFirstItem.basket_id) {
        this.orderBasket = await getBasket(this.currentOrderDetailsFirstItem.basket_id);
        this.orderMarketWindow = this.orderBasket.marketWindow;
      }
    },
    assignLiftingPeriod() {
      if (this.currentOrderDetailsFirstItem) {
        if (
          this.currentOrderDetailsFirstItem.liftingPeriod &&
          this.currentOrderDetailsFirstItem.liftingPeriod.length > 1
        ) {
          return [
            this.convertStringToDate(this.currentOrderDetailsFirstItem.liftingPeriod[0]),
            this.convertStringToDate(this.currentOrderDetailsFirstItem.liftingPeriod[1]),
          ];
        }
        return this.currentOrderDetailsFirstItem.deliveryDate.split(/\s*\-\s*/g).map((item) => {
          return item.trim();
        });
      }
    },
    convertStringToDate(stringDate) {
      return moment(stringDate).format("DD/MM/YYYY");
    },
    closeEditOrderDialog() {
      this.$emit("update:viewEditOrderDialog", false);
      this.$emit("reloadOrders");
    },
    cancelOrder() {
      this.isCancelingOrder = true;
      this.openConfirmationDialog();
    },
    openConfirmationDialog() {
      this.viewEditOrderDialogVisible = false;
      this.viewEditDeleteConfirmationDialog = true;
    },
    showRemovalConfirmation: function (isOpening) {
      if (isOpening) {
        this.viewEditOrderDialogVisible = false;
        // Show removal confirmation modal
        const payload = {
          item: {},
          type: this.$store.getters["itemRemoval/eRemoveItemType"].UnconfirmedChanges,
          showWindow: true,
        };
        this.$store.dispatch("itemRemoval/openConfirmationRemoval", payload);
        setTimeout(() => {
          const removalModal = this.$root.$refs.confirmationRemoveItem.$el;
          $(removalModal).modal({ show: true, keyboard: false });
        }, 250);
      }
    },
    isCostBreakdownDisplayed(orderItem) {
      return this.getAccountType === "seller" && orderItem && orderItem.pricingEngineEnabled;
    },
    async validateForm(formName) {
      return new Promise((res) => {
        this.$refs[formName].validate((valid) => {
          return res(valid);
        });
      });
    },
    openManageOrderNumbersDialog() {
      this.viewEditOrderDialogVisible = false;
      this.viewManageOrderNumbersDialog = true;
    },
    async saveChanges() {
      if (this.isConfirmingOrder && !this.manageOrderNumbersEnabled) {
        this.openConfirmationDialog();
      } else if (this.isConfirmingOrder && this.manageOrderNumbersEnabled) {
        this.openManageOrderNumbersDialog();
      } else {
        let liftingPeriodValid = true;
        if (!this.isBunkering) {
          liftingPeriodValid = await this.validateForm("liftingPeriodForm");
        }
        let formValid = await this.validateForm("form");
        if (formValid && liftingPeriodValid) {
          this.createOrderObject();
          this.openConfirmationDialog();
        }
      }
    },
    disabledStartDates(time) {
      return (
        new Date(this.currentOrderDetailsFirstItem.created).setHours(0, 0, 0, 0) > new Date(time).setHours(0, 0, 0, 0)
      );
    },
    createOrderObject() {
      const order = {
        offers: [],
      };
      order.offers = this.currentOrderDetails.map((offer) => {
        const originalOffer = this.ordersOriginal.find(({ offerId }) => offer.offerId === offerId);
        const updateOffer = {
          _id: offer.offerId,
          quantityOrdered: offer.quantity,
          price: offer.price,
          collectionTime: -1,
          liftingPeriod: [...this.editOrderForm.liftingPeriod],
        };
        if (originalOffer && originalOffer.price !== offer.price) {
          updateOffer.adjustment =
            originalOffer.adjustment + (this.stringToNumber(offer.price) - this.stringToNumber(originalOffer.price));
        }

        return updateOffer;
      });
      this.editOrderForm.offers = [...order.offers];
    },
    tableHeaderClass({ row, rowIndex }) {
      return "dark-header-row";
    },
  },
};
</script>
<style lang="scss">
.el-dialog__footer {
  text-align: center !important;
}

.el-form-item__content {
  margin-left: 0px !important;
}

.el-table--mini td,
.el-table--mini th {
  padding: 1px 0 !important;
}

.customLineHeight {
  .el-col {
    line-height: 2.5;
    color: #73879C;
  }
}

.customFontSize {
  .el-col {
    font-size: 1rem;
  }
}

.el-dialog {
  background-color: #EEF0F1 !important;
}
</style>